module.exports = __webpack_public_path__ + "static/logo-c40704c9d748081da23f745fa702aa9c.png";